import { ENV_CONFIG_ENV_TYPES, EnvironmentConfig } from '../app/environment.config';

export const environment: EnvironmentConfig = {
  production: true,
  idsApiUrl: 'https://identity-qa.mindplay.com/',
  lsApiUrl: 'https://sales.lightsailed.com/',
  mpApiUrl: 'https://api-qa.mindplay.com/',
  fluencyApiUrl: 'https://api-fluency-qa.mindplay.com/',
  screenerApiUrl: 'https://api-screener-qa.mindplay.com/',
  phonicsApiUrl: 'https://api-phonics-qa.mindplay.com/',
  grammarApiUrl: 'https://api-grammar-qa.mindplay.com/',
  academyApiUrl: 'https://academy-qa.mindplay.com/',
  mpCoachUrlStudent: 'https://read-qa.mindplay.com/mvrc/default.aspx',
  mpCoachUrlNonStudent: '',
  mpAccountUrl: 'https://account-qa.mindplay.com/login',
  mpManagerUrl: 'https://manager-qa.mindplay.com/account/login',
  lsV10Url: 'https://sales.lightsailed.com/school/literacy',
  statsPageUrl: 'https://stats.mindplay.com/',
  cleverClientId: '665a46d36204a8d83c43',
  classLinkClientId: 'c1536154019710ee499dfbda6d1a84c98ec4fe27e4f0f2',
  gg4lClientId: 'PTRAPOWSUM',
  googleClientId: '872446888779-bhk2qk4ltdaljpks3vccv76tc5jijg85.apps.googleusercontent.com',
  googleMapsApiKey: 'AIzaSyAdg-bL3yneRMDCovXImPcng0V8-8NxUHI',
  microsoftSSOClientId: 'b32c61df-1250-41c4-a86e-8315b8381933',
  version: '20260601.11',
  applicationInsightsConnectionString:
    'InstrumentationKey=b40cd09f-c712-4153-96e8-95842172d36d;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=b068afe6-c708-445b-a84d-2c5be782f798',
  sandboxCustomerId: 15719,
  environment: ENV_CONFIG_ENV_TYPES.QA,
};
